import React, { useEffect } from 'react'
import { withNamespaces } from 'react-i18next'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import i18next from 'i18next'
import { IsEnglish } from '../../utils/language'
import PropTypes from 'prop-types'
import styles from '../../styles/loginCompany.module.css'
import * as AccessTypeMode from '@scripts/AccessTypeMode';

const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    }
};

function LoginCompanyForm(props) {

    const [company, setCompany] = React.useState(null);

    const { companiesList, onChange } = props;

    const onChangeCompany = (event) => {
        setCompany(event.target.value);
        onChange(event.target.value, AccessTypeMode.Employee);
    }

    return (
        <div className={styles.divRootSelect}>
            <FormControl>
                <div className={styles.divFormSelect}>
                    <InputLabel id="label-companies">{i18next.t('login:login.company.form.company')}</InputLabel>
                    <Select
                        MenuProps={menuProps}
                        labelId="label-companies"
                        id="company"
                        value={company || ''}
                        onChange={onChangeCompany}
                    >
                        {companiesList && companiesList.map((obj, index) =>
                            <MenuItem key={index} className={styles.selectItem} value={obj.company}>{`${obj.company} - ${IsEnglish() ? obj.companyDescriptionEnglish : obj.companyDescriptionFrench}`}</MenuItem>
                        )}
                    </Select>
                </div>
            </FormControl>
        </div>
    )
}

export default withNamespaces(['login'], { wait: true })(LoginCompanyForm);

LoginCompanyForm.propTypes = {
    companiesList: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
}